import React, { useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../components/ui/Spinner";
import logo from "../assets/logo.png";
import { authApi } from "../api/authApi";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setDone(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900/80 p-8 shadow-2xl shadow-blue-900/20">
        <div className="mb-8 text-center">
          <img
            src={logo}
            alt="IntelliWarrior"
            className="mx-auto mb-4 h-40 w-auto max-w-full object-contain"
          />
          <h1 className="text-lg font-semibold text-slate-100">Forgot password</h1>
          <p className="mt-1 text-sm text-slate-400">We&apos;ll email you a reset link if the account exists.</p>
        </div>

        {done ? (
          <div className="space-y-6">
            <p className="rounded-lg border border-emerald-500/30 bg-emerald-900/20 px-3 py-3 text-sm text-emerald-200">
              If that email is registered, you&apos;ll receive a reset link shortly. Check your inbox and spam folder.
            </p>
            <p className="text-center text-sm text-slate-400">
              <Link to="/login" className="font-medium text-emerald-400 hover:text-emerald-300">
                Back to login
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="mb-1 block text-sm text-slate-300">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full rounded-lg border border-slate-700 bg-slate-800 px-3 py-2 text-slate-100 outline-none ring-blue-500 placeholder:text-slate-500 focus:ring-2"
                placeholder="you@company.com"
              />
            </div>

            {error && (
              <div className="rounded-lg border border-red-500/40 bg-red-900/20 px-3 py-2 text-sm text-red-300">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white transition hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? (
                <>
                  <Spinner className="h-4 w-4 border-2 border-white/30 border-t-white" />
                  Sending…
                </>
              ) : (
                "Send reset link"
              )}
            </button>

            <p className="text-center text-sm text-slate-400">
              <Link to="/login" className="font-medium text-emerald-400 hover:text-emerald-300">
                Back to login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
